/**
 * Checks for the `disableGlobalClassNames` property on the `theme` to determine if it should return `classNames`
 *
 * @param theme The theme to check the flag on
 * @param classNames The global class names that apply when the flag is false
 */
export function getGlobalClassNames(classNames, theme) {
    if (theme.disableGlobalClassNames) {
        return {};
    }
    return classNames;
}
//# sourceMappingURL=getGlobalClassNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/styling/lib/styles/getGlobalClassNames.js
// module id = 161
// module chunks = 0